import { TResponse } from "@/module/common";
import Request from "./request";
import { useRequestConfig } from "./types";

//实例化
const req = new Request({
    baseURL: process.env.VUE_APP_BASE_URL,
    timeout: 5000,
    interceptors: {
      // 请求拦截器
      requestInterceptors: config => {
        return config
      },
      // 响应拦截器
      responseInterceptors: result => {
        return result
      },
    },
  })


const request = <D,T=any>(config:useRequestConfig<D>)=>{
    const {method = 'GET'} = config
    if(method === 'get' || method === 'GET'){
        config.params = config.data
    }
    return req.request<TResponse<T>>(config)
}

export default request